/**
 * タイムセールマスタ情報VOクラス
 */
export class TimeSaleDataModel {

  public static PROCES_DIV_REGIST: string = <string>'1';                        // 処理区分(登録)
  public static PROCES_DIV_UPDATE: string = <string>'2';                        // 処理区分(更新)
  public static PROCES_DIV_DELETE: string = <string>'3';                        // 処理区分(削除)

  public OrderCodeFr: string = <string>'';                                      // 受注コード(From)
  public OrderCodeTo: string = <string>'';                                      // 受注コード(To)

  public OrderCode: string = <string>'';                                        // 受注コード
  public CategoryCode: string = <string>'';                                     // カテゴリコード
  public StartDateYMD: string;                                                  // 開始日付
  public StartDateHH: string;                                                   // 開始時刻（時）
  public StartDateMI: string;                                                   // 開始時刻（分）
  public EndDateYMD: string;                                                    // 終了日付
  public EndDateHH: string;                                                     // 終了時刻（時）
  public EndDateMI: string;                                                     // 終了時刻（分）
  public BannerFileNameBfBB: string;                                            // 開催前バナーファイル名(BB)
  public BannerCaptionBfBB: string;                                             // 開催前バナーキャプション(BB)
  public BannerFileNameOnBB: string;                                            // 開催中バナーファイル名(BB)
  public BannerCaptionOnBB: string;                                             // 開催中バナーキャプション(BB)
  public BannerFileNameAfBB: string;                                            // 開催後バナーファイル名(BB)
  public BannerCaptionAfBB: string;                                             // 開催後バナーキャプション(BB)

  public BannerFileNameBfMB: string;                                            // 開催前バナーファイル名(MB)
  public BannerCaptionBfMB: string;                                             // 開催前バナーキャプション(MB)
  public BannerFileNameOnMB: string;                                            // 開催中バナーファイル名(MB)
  public BannerCaptionOnMB: string;                                             // 開催中バナーキャプション(MB)
  public BannerFileNameAfMB: string;                                            // 開催後バナーファイル名(MB)
  public BannerCaptionAfMB: string;                                             // 開催後バナーキャプション(MB)

  public BannerFileNameBfSP: string;                                            // 開催前バナーファイル名(SP)
  public BannerCaptionBfSP: string;                                             // 開催前バナーキャプション(SP)
  public BannerFileNameOnSP: string;                                            // 開催中バナーファイル名(SP)
  public BannerCaptionOnSP: string;                                             // 開催中バナーキャプション(SP)
  public BannerFileNameAfSP: string;                                            // 開催後バナーファイル名(SP)
  public BannerCaptionAfSP: string;                                             // 開催後バナーキャプション(SP)

  public UpdateDate: string;                                                    // 更新日時
  public ConfirmFlg: string;                                                    // 確認フラグ
}
